module.exports = __webpack_public_path__ + "img/core-logo.b6b75b70.png";